import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { request } from "components/utils/Request2";
import { WaterLevel } from "types/index";

const WaterLevelSelect = <Multiple extends boolean = false,>({
	value,
	onChange,
	getOptionDisabled,
	multiple,
}: Omit<SelectProps<WaterLevel, Multiple>, "fetchOptions">) => {

	const onFetchOptions = async() => {

		const response: Array<WaterLevel> = await request({
			url: "waterlevels/measuring-points",
		});

		return {
			options: response,
			totalResults: response.length,
		};
	};

	return (
		<Select
			value={value}
			onChange={onChange}
			fetchOptions={onFetchOptions}
			getOptionDisabled={getOptionDisabled}
			multiple={multiple} />
	);
};

export default WaterLevelSelect;
